/** Wire / gameplay seed kinds for terraforming inventory. */
export enum SeedType {
  Grass = 1,
  Flower = 2
}
